export default function Title({title_bold, title}){
    return(
        <div className="row hleft">
          <h1 className="lighter m_25px">
            {title_bold?<span className="bold">{title_bold}</span>:""} 
            {title}
          </h1>
        </div>
    )
}